import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { installModalBackdropCloseGuard } from './utils/preventModalBackdropClose';

installModalBackdropCloseGuard();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
